export default "__VITE_ASSET__AGvraUR9__"